import React from 'react';
import {NestedMenuItem} from './NestedMenuItem';
import {IconMenuItem} from './IconMenuItem';
import {MenuItemData} from '../definitions';

export interface nesteMenuItemsFromObjectProps {
  menuItemsData: MenuItemData[];
  parent: any,
  isOpen: boolean;
  handleClose: () => void;
  index:number
}

/**
 * Create a JSX element with nested elements creating a nested menu.
 * Every menu item should have a uid provided
 */
export function nestedMenuItemsFromObject({
  menuItemsData: items,
  parent,
  isOpen,
  handleClose,
  index,
}: nesteMenuItemsFromObjectProps) {
  return items.map(item => {
    const {leftIcon, rightIcon, label, items, callback} = item;

    if (items && items.length > 0) {
      // Recurse deeper
      return (
        <NestedMenuItem
          key={label}
          leftIcon={leftIcon}
          rightIcon={rightIcon}
          label={label}
          parentMenuOpen={isOpen}
          index={index}
        >
          {/* Call this function to nest more items */}
          {nestedMenuItemsFromObject({
            menuItemsData: items,
            parent: item,
            isOpen,
            handleClose,
            index,
          })}
        </NestedMenuItem>
      );
    } 
      // No children elements, return MenuItem
      return (
        <IconMenuItem
          key={label}
          leftIcon={leftIcon}
          rightIcon={rightIcon}
          label={label}
          index={index}
          onClick={(e:any) => {
            handleClose();
            callback(e, index, item, parent);
          }}
        />
      );
    
  });
}
